import { CounterBadge, Tabs, TabsList, TabsTrigger } from "@aircall/ds";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { SubRoute, TabMenuProps } from "./TabMenu.decl";
import { useHandlers, useRedirect } from "./TabMenu.hooks";
import { pickActiveTab } from "./TabMenu.utilities";

import { useGetTagsAndNotes } from "@/hooks/useGetTagsAndNotes/useGetTagsAndNotes";
import { usePathParams } from "@/states/path_param";

export function TabMenu({ tabs, disabledTabs }: TabMenuProps) {
  const { t } = useTranslation();
  const location = useLocation();

  const { callId } = usePathParams();

  const { notes } = useGetTagsAndNotes({ callId });

  const { onChangeTab: handleOnChangeTab } = useHandlers();

  useRedirect({ disabledTabs });

  const activeTab = pickActiveTab({
    pathname: location.pathname ?? "",
    tabs,
    disabledTabs,
  });

  return (
    <Tabs orientation="horizontal" value={activeTab}>
      <TabsList data-test="tab-menu">
        {tabs.map((tab: SubRoute) => {
          const disabled = disabledTabs.includes(tab);

          return (
            <TabsTrigger
              key={tab}
              value={tab}
              disabled={disabled}
              onClick={() => handleOnChangeTab(tab)}
              className="cursor-pointer disabled:cursor-not-allowed"
              data-test={`tab-menu-item-${tab}`}
            >
              <span className="text-base font-medium">
                {t(`menu_tabs.${tab}`)}
              </span>
              {tab === "notes" && notes?.length > 0 && (
                <CounterBadge>{notes.length}</CounterBadge>
              )}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
}
